import { flow } from 'lodash';

export const mergeAvailableTimes = (availableTimes, addingAvailableTimes = []) => {
    const mergedAvailableTimes = [...availableTimes];
    const uniqueDates = new Set(mergedAvailableTimes.map((time) => time.date));
    addingAvailableTimes.forEach((time) => {
        if (!uniqueDates.has(time.date)) {
            mergedAvailableTimes.push(time);
        } else {
            const index = mergedAvailableTimes.findIndex((t) => t.date === time.date);
            mergedAvailableTimes[index] = time;
        }
    });
    return mergedAvailableTimes;
};

export const sortDates = (dates) => {
    return dates.sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const getNewAvailableTimes = flow(mergeAvailableTimes, sortDates);
